export default {
    methods: {
        /**
         * Push a notification to the screen.
         * Uses Toasts
         * @link https://bootstrap-vue.org/docs/components/toast
         * @param message
         * @param color
         * @param errors
         */
        popNotification(message, color = 'danger', errors = null, persist = false) {

            // When errors array is supplied, then loop it and turn it into a list
            if(errors !== null) {

                const h = this.$createElement

                let errorList = [];
                let arrayLength = errors.length;
                for (var i = 0; i < arrayLength; i++) {
                    errorList.push(h('li', errors[i]));
                }

                const newMessage = h(
                    'p',
                    { class: [] },
                    [
                        message,
                        h('ul', { class: ['my-0'] }),
                        errorList,
                    ]
                )

                message = newMessage;
            }


            this.$bvToast.toast(message, {
                autoHideDelay: 7000,
                variant: color,
                appendToast: true,
                noAutoHide: persist,
                title: 'Message',
                toaster: 'b-toaster-bottom-left',
                //noCloseButton: !persist, // No close button because we do not use a title. They also close automatically.
            })
        }
    }
};